import CordwoodHistoryName from "./CordwoodHistoryName";
import CordwoodHistoryLink from "./CordwoodHistoryLink";


import CordwoodName from "../../../../timber/components/cordwood/CordwoodDetail/CordwoodName";
import CordwoodLink from "../../../../timber/components/cordwood/CordwoodDetail/CordwoodLink";

import TimberStorageName from "../../../../timber/components/timberStorage/TimberStorageDetail/TimberStorageName";
import TimberStorageLink from "../../../../timber/components/timberStorage/TimberStorageDetail/TimberStorageLink";

import LocationName from "../../../../location/components/location/LocationDetail/LocationName";
import LocationLink from "../../../../location/components/location/LocationDetail/LocationLink";

import CuttingName from "../../../../timber/components/cutting/CuttingDetail/CuttingName";
import CuttingLink from "../../../../timber/components/cutting/CuttingDetail/CuttingLink";

import ShipmentName from "../../../../timber/components/shipment/ShipmentDetail/ShipmentName";
import ShipmentLink from "../../../../timber/components/shipment/ShipmentDetail/ShipmentLink";

import TimberTypeName from "../../../../timber/components/timberType/TimberTypeDetail/TimberTypeName";
import TimberTypeLink from "../../../../timber/components/timberType/TimberTypeDetail/TimberTypeLink";

import TimberClassName from "../../../../timber/components/timberClass/TimberClassDetail/TimberClassName";
import TimberClassLink from "../../../../timber/components/timberClass/TimberClassDetail/TimberClassLink";
import { toStringDisplay as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { toStringDisplay as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { toStringDisplay as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { toStringDisplay as toStringUserType } from "../../../types/models/UserType.d";
import { toStringDisplay as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import {NavLink, useParams} from "react-router";
import Refresh from "@mui/icons-material/Refresh";
import Clear from "@mui/icons-material/Clear";
import Grid from '@mui/material/Grid';
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const CordwoodHistoryDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" justifyContent="left" spacing={1}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="CordwoodHistory-detail-title"
                    >
                        { label || t`Cordwood History` }: <CordwoodHistoryName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" justifyContent="right" spacing={1}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="CordwoodHistory-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="CordwoodHistory-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="cordwoodId-label"><Trans>Cordwood</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="cordwoodId-value" >{ data.cordwoodId ? (<CordwoodLink id={ data.cordwoodId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="action-label"><Trans>Action</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="action-value" >{ data.action || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="contextHistory-label"><Trans>Context History</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="contextHistory-value" >{ data.contextHistory || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="updatedAt-label"><Trans>Updated At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="updatedAt-value" >{displayDateTime(data.updatedAt) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="internalKey-label"><Trans>IK</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="internalKey-value" >{ data.internalKey || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="timberKey-label"><Trans>Timber Key</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="timberKey-value" >{ data.timberKey || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="storageId-label"><Trans>Timber Storage</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="storageId-value" >{ data.storageId ? (<TimberStorageLink id={ data.storageId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="locationId-label"><Trans>Location</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="locationId-value" >{ data.locationId ? (<LocationLink id={ data.locationId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="cuttingId-label"><Trans>Cutting</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="cuttingId-value" >{ data.cuttingId ? (<CuttingLink id={ data.cuttingId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="shipmentId-label"><Trans>Shipment</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="shipmentId-value" >{ data.shipmentId ? (<ShipmentLink id={ data.shipmentId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="volume-label"><Trans>Volume</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="volume-value" >{fixedFormat(data.volume) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="state-label"><Trans>State</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="state-value" >{ toStringShipmentState(data.state) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="measurementType-label"><Trans>MU</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="measurementType-value" >{ toStringCordwoodMeasurementType(data.measurementType) || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="timberTypeId-label"><Trans>Timber Type</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="timberTypeId-value" >{ data.timberTypeId ? (<TimberTypeLink id={ data.timberTypeId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="classId-label"><Trans>Timber Class</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="classId-value" >{ data.classId ? (<TimberClassLink id={ data.classId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="commited-label"><Trans>Commited</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="commited-value" >{ data.commited ? (<CheckBoxOutlinedIcon/>) : (<CheckBoxOutlineBlankOutlinedIcon/>) }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="localCreatedAt-label"><Trans>Local Created At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="localCreatedAt-value" >{displayDateTime(data.localCreatedAt) || '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default CordwoodHistoryDetail;
